var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",class:{'is-icon':_vm.isIcon}},[_c('span',{staticClass:"custom-title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"cont"},[_vm._v(_vm._s(_vm.contText))]),_c('span',{staticClass:"icon",on:{"click":function($event){return _vm.handleClick(_vm.contText)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }